import { FeedPost } from "components";
import FeedPost4 from "components/files/feed/FeedPost4";
import FeedPost6 from "components/files/feed/FeedPost6";
import FeedLayout from "layouts/files/FeedLayout";
import { Link, useParams } from "react-router-dom";
import { SVG } from "ui";

const Hashtag = () => {
    const params = useParams();
    return (
        <FeedLayout pageTitle="trending">
            <div className="moment-mark-page pb-40">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/trending">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">#{params.name}</h1>

                    <div></div>
                </div>
                <FeedPost />
                <FeedPost4 />
                <FeedPost6 />
            </div>
        </FeedLayout>
    );
};

export default Hashtag;
